// "Loading your board" — the empty canvas while the saved board is on its way
// from app-api (boards-bridge.tsx). The markup is plain HTML in index.html
// (#board-loading), so it can show the moment the intro is dismissed, before
// the app's scripts have even loaded (Catalyst's boot-screen pattern); this
// component just takes it over, toggling `.show`. A little bento box builds
// itself: module tiles spring in one after another with the skeleton shimmer,
// the last lit green like the drop ghost, then clear and start again. Hidden
// while the intro is up (main.js adds `html.intro-done` when the user leaves
// it); fades out when the board lands. Styling: `.board-loading*`.

import { useEffect } from "react";

export default function BoardLoading({ show }: { show: boolean }) {
  useEffect(() => {
    document.getElementById("board-loading")?.classList.toggle("show", show);
  }, [show]);
  return null;
}
